/**
 * NormaIncumplidaEvent — renderiza tipo 'norma_incumplida' (GEN-HU-001a).
 * payload: { codigo, enunciado?, no_comprobable?, retenida? }
 * Gemelo de EscalatedEvent: RT-02 (antes del turno) cortó la petición porque
 * incumple una norma general en vigor. El kernel NO llega a responder — este
 * es el único evento del turno, seguido de 'done' (ver `_turno_norma_
 * incumplida` en chat.py). GEN-HU-003: si la norma trae `enunciado` (las de
 * modo semántico; el export de máquina no lo expone) se pinta la norma en
 * letra y el código va entre paréntesis; sin él, solo el código, como antes.
 *
 * GEN-HU-001c: `no_comprobable` (ausente/false salvo cuando aplica) marca
 * que el bloqueo NO es un incumplimiento real sino un FALLO del juez al
 * intentar comprobar la norma (timeout, error, respuesta no parseable) — la
 * petición se detiene igual (fail-closed), pero el título lo dice distinto.
 * Mismo componente, mismo `type` de evento: se reutiliza con un indicador,
 * no se crea uno nuevo.
 *
 * GEN-HU-002: `retenida` marca que RT-08 (fin de turno) retuvo la respuesta
 * ya generada; el hilo no la muestra, solo este aviso con la norma.
 */

import { ShieldAlert } from 'lucide-react'

export default function NormaIncumplidaEvent({ payload }) {
  const { codigo, enunciado, no_comprobable, retenida } = payload
  const titulo = retenida
    ? (no_comprobable
      ? 'La norma no se ha podido comprobar — respuesta retenida'
      : 'Respuesta retenida por una norma en vigor')
    : (no_comprobable
      ? 'La norma no se ha podido comprobar — petición detenida'
      : 'Petición detenida por una norma en vigor')

  return (
    <div className="event-norma-incumplida">
      <div className="norma-incumplida__header">
        <span className="norma-incumplida__icon"><ShieldAlert size={16} strokeWidth={1.8} aria-hidden="true" /></span>
        <span className="norma-incumplida__title">
          {titulo}
        </span>
      </div>
      {enunciado && <p className="norma-incumplida__enunciado">{enunciado}</p>}
      <p className="norma-incumplida__codigo">{enunciado ? `(${codigo})` : codigo}</p>
    </div>
  )
}
